// Status des Mieterportal-Zugangs – dieselbe Quelle wie das Portal-Formular (profiles, Rolle mieter, per E-Mail).

import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../supabase/client';
import { portalStatus, type PortalStatus } from './einheitDetail';

export function usePortalStatus(email: string | null | undefined): { status: PortalStatus; neuLaden: () => void } {
  const [status, setStatus] = useState<PortalStatus>('laedt');
  const [runde, setRunde] = useState(0);
  const adresse = (email ?? '').trim();

  useEffect(() => {
    if (!adresse) { setStatus('ohneEmail'); return; }
    let aktiv = true;
    setStatus('laedt');
    supabase.from('profiles').select('status').eq('email', adresse).eq('role', 'mieter').maybeSingle()
      .then(({ data, error }) => {
        if (!aktiv) return;
        // Ohne Leserecht oder bei Fehlern gilt „kein Zugang“ – wie im Portal-Formular
        setStatus(portalStatus(adresse, error ? null : (data as { status: string | null } | null)?.status));
      });
    return () => { aktiv = false; };
  }, [adresse, runde]);

  const neuLaden = useCallback(() => setRunde(r => r + 1), []);
  return { status, neuLaden };
}
